import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import useRoutes from "./routes";
import NonLayout from "Layout/NonLayout";
interface RouteItem {
  id: string;
  path?: string;
  title?: string;
  icon?: React.ReactNode;
  checkPermission?: boolean;
  component?: React.ReactNode;
  subItems?: RouteItem[];
}

export default function Redirects() {
  const routes = useRoutes();

  const generateRoutes = (
    routeList: RouteItem[],
    parentPath = ""
  ): React.ReactNode[] => {
    return routeList.flatMap((route) => {
      const fullPath = route.path
        ? `${parentPath}${route.path.startsWith("/") ? route.path : `/${route.path}`}`
        : parentPath;

      const elements: React.ReactNode[] = [];

      if (route.component) {
        elements.push(
          <Route
            key={fullPath}
            path={fullPath}
            element={route.component}
          />
        );
      }

      if (route.subItems?.length) {
        elements.push(...generateRoutes(route.subItems, fullPath));
      }

      return elements;
    });
  };

  return (
    <>
      <NonLayout>
        <Routes>{generateRoutes(routes)}</Routes>
      </NonLayout>
    </>
  );
}
